<template>
	<div>
		<div>
			<v-btn icon v-on:click="expanded = !expanded" small>
				<template v-if="expanded">
					<v-icon title="Suskleisti">mdi-menu-up</v-icon>
				</template>
				<template v-else>
					<v-icon title="Išskleisti">mdi-menu-down</v-icon>
				</template>
			</v-btn>
			<span class="font-weight-medium">{{ title || 'Legenda/sluoksniai' }}</span>
		</div>
		<v-card v-show="expanded" flat class="mt-2 ml-7">
			<div>
				<template v-if="legend">
					<template v-if="items">
						<v-treeview v-model="selected" :items="items" :selectable="selectable" selection-type="leaf"
							item-disabled="locked" dense :class="['mb-3', oneLevel ? 'one-level' : '']">
							<template v-slot:label="{ item }">
								<div>{{ item.name }}</div>
								<template v-if="item.html">
									<div v-html="item.html"></div>
								</template>
							</template>
						</v-treeview>
					</template>
					<template v-if="legend == 'error'">
						<div class="body-2">Atsiprašome, šiuo metu sluoksnio turinys nepasiekiamas...</div>
					</template>
					<template v-else-if="legend == 'none'">
						<div class="body-2" v-if="!items">Legendos nėra...</div>
					</template>
					<template v-else>
						<img v-bind:src="legend" class="legend-image" @click="showLegendInDialog">
					</template>
				</template>
				<template v-else>
					<v-progress-circular indeterminate color="primary" :size="20" width="2"></v-progress-circular>
				</template>
			</div>
		</v-card>
	</div>
</template>

<script>
import ServiceHelper from "../../../../../helpers/ServiceHelper";
import TileLayer from "ol/layer/Tile";
import ImageLayer from "ol/layer/Image";
import ImageWMS from "ol/source/ImageWMS";

export default {
	props: {
		layer: Object,
		title: String,
		unselectable: Boolean
	},
	data: function () {
		// Testuoti su https://epaslaugos.am.lt/arcgis/rest/services/STK_PUBLIC/stk/MapServer (https://apptest/inspire-widgets/v2/atlas/413373e2-f720-4aaf-bb65-03752c33f9a9/edit)
		// Testuoti su http://www.geoportal.lt/arcgis/rest/services/NZT/GDR10LT/MapServer
		// !!! http://kaukas:6080/arcgis/rest/services/geoportal_teikeju/ESO_DUJOS_Public/MapServer
		// Dar aktualu nagrinėti C:\servers\apache-tomcat-7.0.67\webapps\inspire\app\Scripts\inspire-app\src\components\parts\MyMapLayerSublayersTree.vue
		var selectable = true;
		if (this.unselectable) {
			selectable = false;
		} else {
			if (this.layer instanceof TileLayer) {
				selectable = false; // TODO: `false` reikšmė taip pat ir peržiūrai skirtame view'e!!!
			}
		}
		var data = {
			expanded: false,
			legend: null,
			items: null,
			selected: [],
			selectable: selectable,
			oneLevel: false,
			wms: false
		};
		return data;
	},
	mounted() {
		ServiceHelper.getLegend(this.layer.service).then(function (legend) {
			this.wms = false;
			if (legend && legend.custom) {
				this.legend = "/map/resources/" + legend.custom;
			} else {
				this.legend = "none";
			}

			if (legend && legend.wms) {
				this.getTreeDataWms(legend.wms);
				this.wms = true;
			}

			if (legend && legend.native) {
				this.getTreeData(legend.native);
			}
		}.bind(this), function () {
			this.legend = "error";
		}.bind(this));
	},
	methods: {
		getTreeDataWms: function (wmsLegendItems) {
			if (!wmsLegendItems || !Array.isArray(wmsLegendItems)) return;

			const buildTree = (layers) => {
				return layers.map(layer => {
					const node = {
						id: layer.name || this.getItemId(),
						name: layer.title || layer.name || "Be pavadinimo",
					};

					if (layer.children && layer.children.length > 0) {
						node.children = buildTree(layer.children);
					} else if (layer.legendUrl) {
						node.html =
							`<span class="legend-row">` +
							`<span><img src="${layer.legendUrl}"></span></span>`;
					}

					return node;
				});
			};

			this.items = buildTree(wmsLegendItems);
			this.oneLevel = false;

			// Surenkame lapų ID (tie, kurie turi legendą)
			this.allIds = [];
			const collectLeafIds = (nodes) => {
				nodes.forEach(n => {
					if (n.children && n.children.length) {
						collectLeafIds(n.children);
					} else {
						this.allIds.push(n.id);
					}
				});
			};
			collectLeafIds(this.items);

			this.selected = [...this.allIds]; // pažymėti visi lapai
		},
		getTreeData: function (nativeLegendItems) {
			if (this.layer.service.capabilities && this.layer.service.capabilities["gisc"]) {
				// Reikia vadovautis C:\servers\apache-tomcat-7.0.67\webapps\map\resources\js\app\navigation\LayerListItemComponents\SublayersList.js !!???
				// Ten elementai medžiui buvo traukiami iš sluoksnio `layerInfos`, kurį sugeneruoja `ArcGIS API for JavaScript`? Čia tokios prabangos neturime...
				// Reikia žiūrėti kokios `layerInfos` reikšmės buvo paduodamos sluoksnių konstruktoriams...
				var capabilities = this.layer.service.capabilities["gisc"];
				if (capabilities.layer) {
					var children = JSON.parse(JSON.stringify(capabilities.layer.children));
					if (children) {
						var selected = [],
							oneLevel = true,
							allIds = [];
						children.some(function (child) {
							if (child.children) {
								oneLevel = false;
								return true;
							}
						});
						this.processCapabLayerChildren(children, nativeLegendItems, selected, allIds);
						if (this.layer.getSource().getParams) {
							var sourceParams = this.layer.getSource().getParams();
							if (sourceParams && typeof sourceParams["layers"] !== "undefined") {
								// Jei sluoksnis turi atributą, nusakantį kokius sublayer'ius jam rodyti, tai medžio checkbox'ų vaizdavimą pagal tai ir rodome, o ne pagal numatytąsias reikšmes...
								selected = sourceParams["layers"].replace("show:", "").split(",");
								if (selected == "-1") {
									selected = [];
								}
							}
						}
						this.items = children;
						this.selected = selected;
						this.oneLevel = oneLevel;
						this.allIds = allIds;
					}
				}
			}
		},
		processCapabLayerChildren: function (children, legendItems, selected, allIds) {
			if (children) {
				children.forEach(function (child) {
					// child.locked = true; // Atseit disable'ina input'ą... Buvo aktualu testuojant...
					if (child.children) {
						this.processCapabLayerChildren(child.children, legendItems, selected, allIds);
					} else {
						delete child.children; // Nes kartais egzistuodavo su `null` reikšme, bet v-treeview komponentui tai nepatiko??... Lygtais tokia klaida būdavo: `TypeError: Cannot set property 'vnode' of undefined`
						if (Number.isInteger(parseInt(child.id))) {
							if (legendItems && legendItems[child.id]) {
								var legendImage = "";
								legendItems[child.id].forEach(function (l) {
									legendImage += '<span class="legend-row"><span><img src="data:image/png;base64,' + l.imageData + '" width="' + l.width + '" height="' + l.height + '"></span>' + (l.label ? '<span><em>' + l.label + '</em></span>' : "") + '</span>';
								}.bind(this));
								child.html = legendImage;
							}
						}
					}
					if (typeof child.id === "undefined") {
						child.id = this.getItemId();
					} else {
						if (child.defaultVisibility) { // !!! Neaišku, ar galima pasitikėti!!!
							if (!child.children) { // Nes nepasitikiu server-side'o algoritmu... Geriau tegul tėvinių item'ų matomumą apsprendžia v-treeview komponentas!
								selected.push(child.id);
							}
						}
						if (!child.children) {
							allIds.push(child.id);
						}
					}
				}.bind(this));
			}
		},
		getItemId: function () {
			if (!this.id) {
				this.id = 0;
			}
			this.id += 1;
			return this.id;
		},
		showLegendInDialog: function () {
			console.log("DO SHOW...", this.legend);
			this.$vBus.$emit("show-legend-dialog", this.legend);
		}
	},
	watch: {
		selected: {
			handler(selectedLayers) {
				if (this.selectable) {
					// !!! Labai svarbus eiliškumas??... Bent jau WMS sluoksniams? Priklausomai nuo to, kokiu eiliškumu bus pateikti sublayer'iai, taip jie ir atsivaizduos?
					// Mums tai negerai, nes medis tai nesikeičia...
					// Todėl reikia pergrupuoti pažymėtų sublayer'ių masyvą taip, kad atitiktų originalią sublayer'ių eiliškumo tvarką?...					
					if (selectedLayers && this.allIds) {
						var selectedLayersDict = {},
							selectedLayersWithProperOrder = [];
						selectedLayers.forEach(function (selectedLayer) {
							selectedLayersDict[selectedLayer] = true;
						});
						this.allIds.forEach(function (id) {
							if (selectedLayersDict[id]) {
								selectedLayersWithProperOrder.push(id);
							}
						});
						selectedLayers = selectedLayersWithProperOrder;
					}
					var show;
					if (selectedLayers) {
						var showLayers = selectedLayers;
						if(this.wms){
							showLayers = selectedLayers.reverse();
						}
						show = showLayers.join(",");
					}
					if (this.layer instanceof ImageLayer && this.layer.getSource() instanceof ImageWMS) {
						this.layer.getSource().updateParams({
							"layers": show
						});
					} else {
						if (!show) {
							show = "-1";
						}
						this.layer.getSource().updateParams({
							"layers": "show:" + show
						});
					}
					this.layer.getSource().refresh();
				}
			}
		}
	}
}
</script>

<style scoped>
.legend-image {
	max-width: 100%;
	border: 1px solid #dddddd;
	cursor: pointer;
}
</style>